import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Layout from "../components/Layout";

const PrivateWrapper = () => {
  const isAuthenticated = localStorage.getItem("token");

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  } else {
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  }
};

export default PrivateWrapper;
